// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class TransientInteraction {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): TransientInteraction {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsTransientInteraction(bb: flatbuffers.ByteBuffer, obj?: TransientInteraction): TransientInteraction {
    return (obj || new TransientInteraction()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsTransientInteraction(
    bb: flatbuffers.ByteBuffer,
    obj?: TransientInteraction
  ): TransientInteraction {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new TransientInteraction()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  interactionId(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  timeout(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : null
  }

  static startTransientInteraction(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addInteractionId(builder: flatbuffers.Builder, interactionIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, interactionIdOffset, 0)
  }

  static addTimeout(builder: flatbuffers.Builder, timeout: number) {
    builder.addFieldInt32(1, timeout, null)
  }

  static endTransientInteraction(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createTransientInteraction(
    builder: flatbuffers.Builder,
    interactionIdOffset: flatbuffers.Offset,
    timeout: number | null
  ): flatbuffers.Offset {
    TransientInteraction.startTransientInteraction(builder)
    TransientInteraction.addInteractionId(builder, interactionIdOffset)
    if (timeout !== null) TransientInteraction.addTimeout(builder, timeout)
    return TransientInteraction.endTransientInteraction(builder)
  }
}
